import React from 'react';
import { Link } from 'react-router-dom';
import useDarkMode from "../../hooks/useDarkMode";
// import icons from '../../assets/icon-all';


const BreadCrumbs = ({
  match,
  history,
  prevPath
}) => {
  const dark = useDarkMode();
  const textColor = dark ? "#e5e7eb" : "#333";
  const iconColor = dark ? "#cbd5f5" : "#666";
  const homeColor = dark ? "#e5e7eb" : "#4d4d4d";
  const crumbs = match.url.split('/').filter(t => t);
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        // flexWrap: 'wrap',
        paddingBottom: "10px",
        color: textColor,
      }}
    >
      <div
        onClick={() => {
          // if (prevPath) {
          //   history.push(prevPath)
          // } else {
          //   history.push("/")
          // }
          history.goBack()
        }}
        style={{
          cursor: 'pointer',
          display: "flex",
          alignItems: 'center',
          // textDecoration: "underline",
          color: textColor,
        }}
      >
        {/* {icons.chevronLeft} */}
        {/* "chevronleft" */}
        <i className="material-icons" style={{ color: iconColor }}>chevron_left</i>
        <span
          style={{
            marginLeft: "-6px"
          }}
        >
          Go Back
        </span>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
        className="flex-small-column"
      >
        <Link
          to="/"
          style={{
            color: homeColor,
            textDecoration: "underline"
          }}
        >
          Home
        </Link>
        <div
          style={{
            display: 'flex',
            // flexDirection: "column"
          }}
          className="flex-small-column"
        >
          {crumbs.map((crumb, index) => {
            const link = crumbs.slice(0, index+1).join("/")
            
            return (
              <div
                key={crumb+"slash"}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    padding: "0px 0px 0px 0px",
                    display: 'flex',
                    marginRight: "-10px",
                    color: iconColor,
                  }}
                >
                  {/* {icons.chevronRight} */}
                  {/* chevronright */}
                  <i className="material-icons">chevron_right</i>
                </div>
                <Link
                  to={`/${link}`}
                  style={{
                    padding: "0px 4px",
                    color: textColor,
                    textTransform: "capitalize",
                    textDecoration: "underline",
                  }}
                >
                  {crumb}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default BreadCrumbs;